<template>
  <div class="IdentifyRecord page-padding">
    <!-- <span class="iconfont-lunan icon-lunan-return return" @click="returnBack"
      >返回识别中心</span
    > -->
    <el-button v-if="$route.query.type"
               type="primary"
               class="return"
               style="padding: 7px 7px"
               icon="iconfont icon-iconfontfanhui"
               @click="returnBack">返回识别中心</el-button>
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="行人"
                   name="first"> </el-tab-pane>
      <el-tab-pane label="机动车辆"
                   name="second"></el-tab-pane>
    </el-tabs>
    <div class="record_content">
      <div class="record_search">
        <label>时间：</label>
        <el-date-picker type="datetime"
                        placeholder="请选择开始时间"
                        v-model="startTime"
                        default-time="00:00:00"
                        style="width: 182px"></el-date-picker>
        <span style="padding: 0 5px">至</span>
        <el-date-picker type="datetime"
                        placeholder="请选择结束时间"
                        v-model="endTime"
                        default-time="23:59:59"
                        style="width: 182px"></el-date-picker>
        <div class="flex-row"
             v-if="typeValue == 2">
          <div class="valign-center"
               style="margin-left: 10px">车牌号：</div>
          <div>
            <el-input v-model="plateNo"
                      placeholder="请输入车牌号"
                      clearable></el-input>
          </div>
        </div>
        <div class="flex-row devicename">
          <div class="valign-center"
               style="margin-left: 10px; width: 95px">
            设备名称：
          </div>
          <el-select v-model="deviceName"
                     placeholder="请选择设备名称"
                     filterable
                     clearable>
            <el-option v-for="i in deviceData"
                       :key="i.id"
                       :value="i.deviceName">
            </el-option>
          </el-select>
          <!-- 
          <el-input
            placeholder="请选择设备名称"
            v-model="deviceName"
          ></el-input>
        <el-button type="text" @click="selectDevice">请选择</el-button> -->
        </div>
        <div class="flex-row">
          <div class="valign-center"
               style="margin-left: 10px">区域：</div>
          <div class="input_choice">
            <el-input :disabled="disabled"
                      v-model="areaName"> </el-input>

            <el-button type="text"
                       @click="showTree">请选择</el-button>
            <!-- <el-select> </el-select> -->
            <el-dialog title="选择区域"
                       :append-to-body="true"
                       :visible.sync="areaVisible"
                       width="400px">
              <el-input prefix-icon="el-icon-search"
                        style="margin-bottom: 10px"
                        placeholder="请输入搜索关键字"
                        v-model="filterText"
                        clearable>
              </el-input>
              <el-scrollbar height="80%">
                <el-tree style="height: 80%"
                         default-expand-all
                         show-checkbox
                         ref="dialogTree"
                         :data="areaTree"
                         :props="areaProps"
                         node-key="areaDevGroupCode"
                         :filter-node-method="filterNode"
                         v-model="areaName"
                         placeholder="请输入区域名称"></el-tree>
              </el-scrollbar>
              <div slot="footer">
                <el-button @click="areaConcel">取消</el-button>
                <el-button type="primary"
                           @click="areaConfirm">确认</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
        <div class="search-radio"
             v-if="typeValue == '1'">
          <el-radio v-model="isStrangePerson"
                    label="">全部</el-radio>
          <el-radio v-model="isStrangePerson"
                    label="1">陌生人</el-radio>
          <el-radio v-model="isStrangePerson"
                    label="3">员工</el-radio>
          <el-radio v-model="isStrangePerson"
                    label="4">外来人员</el-radio>
        </div>
        <div class="search-radio"
             v-if="typeValue == '2'">
          <el-radio v-model="isStrangeCar"
                    label="0">全部</el-radio>
          <el-radio v-model="isStrangeCar"
                    label="1">陌生车辆</el-radio>
        </div>
        <span class="record_searchbtn">
          <el-button @click="queryList"
                     type="primary">查询</el-button>
          <el-button @click="resetRecord"
                     type="info">重置</el-button>
        </span>
      </div>
      <IdentifyList ref="IdentifyList"
                    custom-class="row"
                    :show-track="false"
                    :data="strangerList"
                    :isRecord="isRecord"
                    :typeValue="typeValue"
                    @queryMatchRecord="queryMatchRecord">
      </IdentifyList>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination class="mt10 mb10"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       :page-size="page.pageSize"
                       :total="page.total"
                       :current-page="page.currentPage"
                       @size-change="sizeChange"
                       @current-change="pageChange"
                       @prev-click="pageChange"
                       @next-click="pageChange" />
      </div>
    </div>
    <el-dialog title="设备"
               :visible.sync="isShow"
               width="400px"
               height="350px">
      <camera-tree :typeValue="typeValue"
                   ref="cameraTree"
                   @currentChange="currentChange"></camera-tree>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary"
                   @click="deviceConfirm">确认</el-button>
      </div>
    </el-dialog>
    <!-- <app-camers-group
      ref="areaTree"
      :expandAll="false"
      :showType="false"
      @saveChecked="changeCamersGroup"
    /> -->
  </div>
</template>

<script>
import { api } from "../api";
import { Dates } from "$utils";
import utils from "@src/common/utils";
import IdentifyList from "../components/IdentifyList";
import appCamersGroup from "@src/components/business/app-area-tree";
import cameraTree from "../components/cameraTree";
export default {
  components: {
    IdentifyList,
    //   appCamersGroup,
    cameraTree,
  },
  data () {
    return {
      isShow: false,
      disabled: true,
      areaList: [],
      areaTree: [],
      filterText: "",
      areaVisible: false,
      areaProps: {
        label: "areaDevGroupName",
        children: "areaChildren",
        isLeaf: "isLeaf",
      },
      deviceName: "",
      strangerList: [],
      plateNo: "",
      areaName: "",
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      activeName: "first",
      timeRange: [],
      startTime: "",
      endTime: "",
      isStrangePerson: "3",
      isStrangeCar: "1",
      typeValue: 1,
      //区域名称
      nameList: [],
      isRecord: true,
      deviceData: [],
    };
  },
  watch: {
    filterText (val) {
      this.$refs.dialogTree.filter(val);
    },
  },

  mounted () {
    this.initRecord();
    this.queryControlTaskCamera();
  },
  methods: {
    queryControlTaskCamera () {
      let params = {
        controlFlag: 1,
        controlType: this.typeValue,
      };
      this.$fetch(api.queryControlTaskCamera, params).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj;
        }
      });
    },
    currentChange (data) {
      this.deviceData = data;
    },

    //选择布控相机
    selectDevice () {
      this.isShow = true;
    },
    cancel () {
      this.deviceName = "";
      this.isShow = false;
    },
    //暂时不使用
    deviceConfirm () {
      if (this.deviceData != null) {
        this.deviceName = this.deviceData.name;
        this.isShow = false;
      } else {
        this.$message.warning("请选择至少一个设备");
      }
      //  this.$refs.cameraTree.getCheckedNodes()
    },
    areaConcel () {
      this.areaVisible = false;
    },
    areaConfirm () {
      let checkedData = [...this.$refs.dialogTree.getCheckedNodes()];
      const areaName = [];
      this.areaList = [];
      checkedData.forEach((val) => {
        this.areaList.push(val.areaDevGroupCode);
        areaName.push(val.areaDevGroupName);
      });
      this.areaName = areaName.join(",");
      this.areaVisible = false;
      //this.queryMatchRecord();
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    changeCamersGroup (data) {
      const areaName = [];
      this.areaList = [];
      data.forEach((val) => {
        this.areaList.push(val.areaDevGroupCode);
        areaName.push(val.areaDevGroupName);
      });
      this.areaName = areaName.join(",");
    },
    showTree () {
      this.areaVisible = true;
      //获取默认区域树结构
      this.$fetch("/cms/area/queryAreaByAccountName.json").then((res) => {
        if (res && res.success) {
          if (this.showType) {
            this.areaTree = [...res.returnObj];
          } else {
            this.areaTree = this.menusComDataPro(res.returnObj);
          }
        } else {
          this.$message.error("获取数据失败,请稍后再试");
        }
      });
      this.$nextTick(() => {
        this.$refs.dialogTree.setCheckedKeys(this.areaList);
      });
    },
    //递归树结构
    menusComDataPro (data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          // entity.areaChildren = item.areaChildren;
          entity.areaDevGroupCode = item.areaDevGroupCode;
          entity.areaDevGroupName = item.areaDevGroupName;
          entity.parentCode = item.parentCode;
          entity.isLeaf = !item.hasLeaf || !item.integratedGroupChildren;
          if (item.areaChildren && item.parentCode == "-1") {
            entity.areaChildren = self.menusComDataPro(item.areaChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.queryMatchRecord();
    },
    pageChange (currentPage) {
      this.page.currentPage = currentPage;
      this.queryMatchRecord();
    },
    handleClick (val) {
      if (val.index === "0") {
        this.typeValue = 1;
      } else {
        this.typeValue = 2;
      }
      this.deviceName = "";
      this.queryMatchRecord();
      this.queryControlTaskCamera();
      // this.$nextTick(() => {
      //   this.$refs.cameraTree.queryControlTaskCamera(this.typeValue);
      // });
    },
    returnBack () {
      this.$router.push({ path: "/access/identifyCenter" });
    },
    initRecord () {
      this.typeValue = 1;
      this.matchArea = [];
      this.startTime = "";
      this.endTime = "";
      this.timeRange = [];
      this.pageNum = 1;
      this.pageSize = 10;
      this.queryMatchRecord();
    },
    //查询按钮触发事件
    queryList () {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      // this.nameList = [];
      // this.areaName = "";
      this.queryMatchRecord();
    },
    queryMatchRecord () {
      let params = {
        matchType: this.typeValue,
        areaList: this.areaList,
        //  isStrange: this.isStrange == "1" ? "1" : "",
        startTime: Dates.format(this.startTime) || "",
        endTime: Dates.format(this.endTime) || "",
        deviceName: this.deviceName,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        // areaName: this.areaName,
      };
      if (this.typeValue != "1") {
        params.plateNo = this.plateNo;
        params.isStrange = this.isStrangeCar;
      } else {
        params.personnelType;
        if (this.isStrangePerson > 1) {
          params.personnelType = this.isStrangePerson - 2;
        } else {
          params.isStrange = this.isStrangePerson;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryRecordList, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (res.success) {
          this.strangerList = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
      // this.areaList = [];
    },
    resetRecord () {
      this.matchArea = [];
      this.startTime = "";
      this.endTime = "";
      this.areaList = [];
      this.plateNo = "";
      this.pageNum = 1;
      this.pageSize = 10;
      this.areaName = "";
      this.deviceName = "";
      this.isStrangePerson = "3";
      this.queryMatchRecord();
    },
  },
};
</script>

<style lang="scss">
@import "../style/IdentifyRecord.scss";
.input_choice,
.devicename {
  position: relative;
  .el-button {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>
